import { functions } from "./firebase";

const CALLABLE_TIMEOUT_MS = 30_000;

export const DATA_FLAG_BASIS_OPTIONS = [
  { value: "incorrect_capabilities", label: "Incorrect diagnostic capabilities" },
  { value: "wrong_hours", label: "Wrong hours of operation" },
  { value: "wrong_contact", label: "Wrong contact information" },
  { value: "permanently_closed", label: "Facility permanently closed" },
];

export const CHALLENGE_BASIS_OPTIONS = [
  { value: "no_longer_affiliated", label: "Claimant no longer affiliated with this facility" },
  { value: "i_am_the_administrator", label: "I am the legitimate administrator" },
  { value: "fraudulent_claim", label: "Fraudulent or unauthorized claim" },
];

export async function submitEdLocationDataFlag({ locationId, basis, specifics }) {
  const callable = functions.httpsCallable("submitEdLocationDataFlag", {
    timeout: CALLABLE_TIMEOUT_MS,
  });
  const response = await callable({ locationId, basis, specifics });
  return response?.data || null;
}

export async function declineEdLocationDataFlag({ flagId, declineReason }) {
  const callable = functions.httpsCallable("declineEdLocationDataFlag", {
    timeout: CALLABLE_TIMEOUT_MS,
  });
  const response = await callable({ flagId, declineReason });
  return response?.data || null;
}

export async function closeEdLocationDataFlag({ flagId, resolutionNote, confirmCorrection }) {
  const callable = functions.httpsCallable("closeEdLocationDataFlag", {
    timeout: CALLABLE_TIMEOUT_MS,
  });
  const response = await callable({ flagId, resolutionNote, confirmCorrection });
  return response?.data || null;
}

export async function confirmDataFlagInferenceCandidate({ flagId, candidateId, confirmed }) {
  const callable = functions.httpsCallable("confirmDataFlagInferenceCandidate", {
    timeout: CALLABLE_TIMEOUT_MS,
  });
  const response = await callable({ flagId, candidateId, confirmed });
  return response?.data || null;
}

export async function submitEdLocationClaimChallenge({ locationId, npi, basis, note }) {
  const callable = functions.httpsCallable("submitEdLocationClaimChallenge", {
    timeout: CALLABLE_TIMEOUT_MS,
  });
  const response = await callable({ locationId, npi, basis, note });
  return response?.data || null;
}

export async function submitEdClaimChallengeReply({ challengeId, text }) {
  const callable = functions.httpsCallable("submitEdClaimChallengeReply", {
    timeout: CALLABLE_TIMEOUT_MS,
  });
  const response = await callable({ challengeId, text });
  return response?.data || null;
}

export async function adjudicateEdLocationClaimChallenge({
  challengeId,
  action,
  adjudicationNote,
  transferToChallenger,
}) {
  const callable = functions.httpsCallable("adjudicateEdLocationClaimChallenge", {
    timeout: CALLABLE_TIMEOUT_MS,
  });
  const response = await callable({
    challengeId,
    action,
    adjudicationNote,
    transferToChallenger,
  });
  return response?.data || null;
}

const edLocationChallengeService = {
  DATA_FLAG_BASIS_OPTIONS,
  CHALLENGE_BASIS_OPTIONS,
  submitEdLocationDataFlag,
  declineEdLocationDataFlag,
  closeEdLocationDataFlag,
  confirmDataFlagInferenceCandidate,
  submitEdLocationClaimChallenge,
  submitEdClaimChallengeReply,
  adjudicateEdLocationClaimChallenge,
};

export default edLocationChallengeService;
